export enum Elevation {
  Elevation_1 = "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
  Elevation_2 = "0 2px 5px 0 rgba(0, 0, 0, 0.5)",
  Elevation_3 = "0 3px 10px 0 rgba(0, 0, 0, 0.3)",
  Elevation_4 = "0 1px 3px 0 rgba(0, 0, 0, 0.16), 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.16)",
  // Deprecated
  Soft = "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
  Lowest = "0 2px 8px rgba(0, 0, 0, 0.2)",
  Low = "0 0 12px rgba(0, 0, 0, .3)",
  Medium = "0 2px 4px 0 rgba(0, 0, 0, .5)",
}
